
import {defineComponent, PropType} from 'vue'
import {PagerItem, PagerHtmlItem as PHI, PagerLinkItem as PLI} from "@/types";
import PagerHtmlItem from "@/components/pager/PagerHtmlItem.vue";
import PagerLinkItem from "@/components/pager/PagerLinkItem.vue";

export default defineComponent({
    name: "PagerItem",
    components: {PagerLinkItem, PagerHtmlItem},
    props: {
        pagerItem: {
            type: Object as PropType<PagerItem>,
            required: true,
        }
    },
    computed: {
        isHtmlItem(): boolean {
            return ("html" in this.pagerItem) && this.pagerItem.html !== "";
        }
    },
    setup() {
        const keyPrefix = (Math.random() * 100000).toFixed(0);

        return {
            keyPrefix: keyPrefix,
        };
    },
})
